import z from "zod/v4";

export const FRONTIERS_SCHEMA = z.array(
  z.object({
    counter: z.number(),
    peer: z.templateLiteral([z.number()]),
  })
);